import type { ReactNode } from "react";

export interface Sponsor {
  name: string;
  alt: string;
  src?: string;
}

export const WELCOME_SPONSORS: Sponsor[] = [
  {
    name: "a16z",
    src: "/img/a16z-logo.png",
    alt: "Andreessen Horowitz (a16z)",
  },
  {
    name: "NBA Foundation",
    src: "/img/nba-foundation-logo.png",
    alt: "NBA Foundation",
  },
  {
    name: "Stripe",
    src: "/img/stripe-logo.png",
    alt: "Stripe",
  },
  {
    name: "Plug In Ventures",
    src: "/img/plugin-ventures-logo.png",
    alt: "Plug In Ventures",
  },
];

export interface LeftPanelBlock {
  tag: string;
  headline: ReactNode;
  body: string;
  stats?: { k: string; l: string }[];
  supportedBy?: Sponsor[];
}

export const LEFT_PANEL_BLOCKS: LeftPanelBlock[] = [
  {
    tag: "Dealflow · by Equal IQ",
    headline: "Run your deals in one place.",
    body: "Every contract, invoice, and payment, organized from your inbox. Ari, your assistant, handles the admin so your team can focus on the deals.",
    supportedBy: WELCOME_SPONSORS,
  },
  {
    tag: "Tell us about you",
    headline: (
      <>
        We tailor the
        <br />
        workspace to your role.
      </>
    ),
    body: "Music agents see catalog deals. Sports agents see endorsements. We surface the right templates, contacts, and signals.",
  },
  {
    tag: "Your workspace",
    headline: (
      <>
        One company.
        <br />
        One source of truth.
      </>
    ),
    body: "Every deal, every contract, every dollar — viewable by you and the teammates you choose. SOC 2 compliant.",
  },
  {
    tag: "Invite your team",
    headline: (
      <>
        Role-based access
        <br />
        from day one.
      </>
    ),
    body: "Owners see everything. Negotiators draft contracts. Analysts read-only. Configure once, change anytime.",
  },
  {
    tag: "Connect your stack",
    headline: (
      <>
        Dealflow becomes
        <br />
        your business inbox.
      </>
    ),
    body: "Gmail brings your deals in. Stripe brings the money in. Plaid keeps your bank reconciled. Nothing leaves your accounts — we just read.",
  },
  {
    tag: "Building your workspace",
    headline: (
      <>
        Ari is reading
        <br />
        your inbox.
      </>
    ),
    body: "Parsing emails, identifying counterparties, attaching contracts, and building your pipeline. This usually takes 30 seconds.",
  },
];
